import { gql } from '@apollo/client';
import { useQuery } from '@hooks/apollo';

export const GET_ADDRESS = gql`
  query{
    user {
    id
    address {
      street
      extNumber
      intNumber
      zip
      neighborhood
      municipality
      state {
        name
      }
      }
    }
  }
`;

export const useGetAddressQuery = (options = {}) => useQuery(GET_ADDRESS, {
  ...options,
});
